
import { ReactNode } from "react";
import Footer from "../../components/Footer";
import { TemplatePageStyle } from "./styles";
import Header from "../../components/Header";

const TemplatePage = ({ children }: { children: ReactNode }) => {    

    return (
        <>
            <Header />
            <main style={TemplatePageStyle.mainContainer} >{children}</main>
            <Footer />
        </>
    )
}

export default TemplatePage;